import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { createVenue, fetchVenue, updateVenue } from '../../../api/VenuesAPI';
import { handleApiError } from '../../../api/risapi';
import { capitalizeFirstLetter } from '../../../commonfunctions';
import AppBreadCrumb from '../../../components/common/AppBreadCrumb';
import AppToaster from '../../../components/AppToaster'; // Import the toaster

const VenuesForm = ({ formType }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [venue, setVenue] = useState({ name: '', location: '', notes: '' });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    // Toaster state
    const [showToaster, setShowToaster] = useState(false);
    const [toaster, setToaster] = useState({});

    const isEditMode = formType === 'edit';

    useEffect(() => {
        if (isEditMode && id) {
            setIsLoading(true);
            fetchVenue(id, (response) => {
                setIsLoading(false);
                if (response.venue) {
                    setVenue(response.venue);
                }
            });
        }
    }, [id, isEditMode]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setVenue(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (exitForm) => {
        setIsLoading(true);
        setErrors({});

        const apiCall = isEditMode ? updateVenue : createVenue;
        apiCall(venue, (response) => {
            setIsLoading(false);
            if (response.venue) {
                const successMessage = `Venue ${isEditMode ? 'updated' : 'created'} successfully!`;
                if (exitForm) {
                    // Navigate with state for the list page to show the toaster
                    navigate('/club_portal/venues', { state: { message: successMessage } });
                } else {
                    // Show toaster directly on this page for "Save + Next"
                    setShowToaster(true);
                    setToaster({ type: 'success', heading: 'Success!', message: successMessage });
                    setVenue({ name: '', location: '', notes: '' }); // Reset form
                }
            } else {
                handleApiError(response, setErrors);
            }
        });
    };
    
    const title = isEditMode ? `Edit Venue` : 'Create New Venue';

    return (
        <>
            <AppToaster showToaster={showToaster} setShowToaster={setShowToaster} toaster={toaster} />
            <main>
                <div className="container-fluid">
                    <AppBreadCrumb title={title}>
                        <li><a className="f-s-14 f-w-500" href="#">Club Admin</a></li>
                        <li><a className="f-s-14 f-w-500" href="/club_portal/venues">Venues</a></li>
                        <li className="active"><a className="f-s-14 f-w-500" href="#">{capitalizeFirstLetter(formType)}</a></li>
                    </AppBreadCrumb>
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header"><h5>{isEditMode ? `Editing: ${venue.name}` : 'Venue Details'}</h5></div>
                                <div className="card-body">
                                <form className="app-form">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div>
                                                <label className="form-label">Venue Name *</label>
                                                <input className="form-control" placeholder="Enter Venue Name" value={venue.name} name="name" onChange={handleInputChange} required type="text" />
                                            </div>
                                            <div className="mb-3"><span className="text-danger">{errors?.name}</span></div>
                                        </div>
                                        <div className="col-md-12">
                                            <div>
                                                <label className="form-label">Location</label>
                                                <input className="form-control" placeholder="Enter Location" value={venue.location} name="location" onChange={handleInputChange} type="text" />
                                            </div>
                                            <div className="mb-3"><span className="text-danger">{errors?.location}</span></div>
                                        </div>
                                        <div className="col-md-12">
                                            <div>
                                                <label className="form-label">Notes</label>
                                                <textarea className="form-control" placeholder="Enter any notes" value={venue.notes} name="notes" onChange={handleInputChange} rows="3"></textarea>
                                            </div>
                                                <div className="mb-3"><span className="text-danger">{errors?.notes}</span></div>
                                        </div>
                                        <div className="col-12">
                                            <div className="text-end">
                                                {!isEditMode ? (
                                                    <>
                                                        <button className="btn btn-outline-primary me-2 btn-sm" type="button" onClick={() => handleSubmit(false)}>Save + Next</button>
                                                        <button className="btn btn-primary me-2 btn-sm" type="button" onClick={() => handleSubmit(true)}>Save + Exit</button>
                                                        <button className="d-none d-md-inline-block btn btn-danger btn-sm" onClick={() => setVenue({ name: '', location: '', notes: '' })} type="reset">Reset</button>
                                                    </>
                                                ) : (
                                                    <>
                                                        <button className="btn btn-primary me-2 btn-sm" type="button" onClick={() => handleSubmit(true)} disabled={isLoading}>
                                                            {isLoading ? 'Updating...' : 'Update Venue'}
                                                        </button>
                                                        <button className="btn btn-danger btn-sm" type="button" onClick={() => navigate('/club_portal/venues')}>Cancel</button>
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default VenuesForm;

